var o = /* @__PURE__ */ ((r) => (r.PRIMARY = "primary", r.SECONDARY = "secondary", r.GHOST = "ghost", r.LINK = "link", r.TOOLBAR = "toolbar", r))(o || {});
export {
  o as BUTTON_VARIANTS
};
//# sourceMappingURL=button-variants.js.map
